import { InputButtonProps } from './InputButton.types';
import { ButtonWrapper, InputGroup, InputWrapper } from './InputButton.styles';
import Button from '../Button/Button';
import Input from '../Input/Input';

const InputButton: React.FC<InputButtonProps> = ({ buttonProps, inputProps }) => (
  <InputGroup>
    <InputWrapper>
      <Input {...inputProps} />
    </InputWrapper>
    <ButtonWrapper>
      <Button {...buttonProps} />
    </ButtonWrapper>
  </InputGroup>
);

export default InputButton;
